import * as React from "react";
import isBrowser from "../../../services/isBrowser";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
export const Modal = ({
    children,
    active,
    onClose
}: {
    children: any;
    active: boolean;
    onClose?: () => void;
}) => {
    React.useEffect(() => {
        if (!isBrowser() || !active) return;
        document.body.style.overflowY = "hidden";
        return () => {
            if (!isBrowser()) return;
            document.body.style.overflowY = "auto";
        };
    }, [active]);

    return (
        <>
            <div
                className={`fixed overflow-y-auto ${
                    active ? "left-[0px] opacity-100" : "left-[100vw] opacity-0"
                } shadow-top-bottom top-[62px] bottom-[72px] z-[300] w-screen bg-zinc-600 bg-opacity-20 transition-all duration-500`}
            >
                <div className="absolute top-0 bottom-0 left-0 right-0 bg-white opacity-100">
                    {children}
                </div>
            </div>
            <div className={`fixed top-[70px] right-[10px] rounded-full bg-zinc-200 p-[3px] z-[400] transition-opacity duration-500 ${active ? "opacity-100" : "opacity-0 right-[-100vw]"}`} onClick={onClose}>
                <CloseOutlinedIcon className="text-zinc-800 relative bottom-px text-2xl" />
            </div>
        </>
    );
};
